import {  NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpRequestInterceptor } from '../interceptors/HttpRequestInterceptor';
import { HandleHttpErrorInterceptor } from '../interceptors/handle-httperror.interceptor';

@NgModule({
  providers: [
    HttpRequestInterceptor,
    HandleHttpErrorInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleHttpErrorInterceptor,
      multi: true
    },
  ],
  
})
export class GspInterceptorsModule { }